import { BACKEND_URL } from '../config';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Leaf, CheckCircle } from 'lucide-react';

const PaymentSuccess = ({ token, onUserUpdate }) => {
  const navigate = useNavigate();
  const [verifying, setVerifying] = useState(true);

  useEffect(() => {
    // Check payment status
    const checkStatus = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/payment/status`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          const data = await response.json();
          if (data.has_paid) {
            onUserUpdate();
            setVerifying(false);
          } else {
            // Still checking, retry in 2 seconds
            setTimeout(checkStatus, 2000);
          }
        }
      } catch (err) {
        console.error('Error checking payment:', err);
        setVerifying(false);
      }
    };

    checkStatus();
  }, [token, onUserUpdate]);

  return (
    <div className="payment-success-page">
      <header className="app-header">
        <div className="header-content">
          <div className="logo">
            <Leaf size={32} />
            <span>BoAI</span>
          </div>
        </div>
      </header>

      <div className="success-content">
        <div className="container">
          <div className="success-card">
            {verifying ? (
              <>
                <div className="loading-spinner"></div>
                <h2>Verifying Payment...</h2>
                <p>Please wait while we confirm your payment</p>
                <p className="hindi-text">कृपया प्रतीक्षा करें जब हम आपके भुगतान की पुष्टि करते हैं</p>
              </>
            ) : (
              <>
                <CheckCircle size={80} className="success-icon" />
                <h2>Payment Successful!</h2>
                <p className="hindi-text">भुगतान सफल!</p>
                <p>You now have access to premium features:</p>
                <ul className="features-list">
                  <li>✓ Unlimited crop disease scans</li>
                  <li>✓ Advanced AI analysis</li>
                  <li>✓ Detailed treatment recommendations</li>
                  <li>✓ Prevention strategies & best practices</li>
                  <li>✓ Full scan history</li>
                  <li>✓ Priority support</li>
                </ul>
                <button 
                  className="btn-primary" 
                  onClick={() => navigate('/dashboard')}
                  data-testid="goto-dashboard-btn"
                >
                  Go to Dashboard / डैशबोर्ड पर जाएं
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
